// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  firebase: {
    projectId: 'riise-4098d',
    appId: '1:112102094490:web:9a43ab979ceb4f8cd99123',
    storageBucket: 'riise-4098d.appspot.com',
    locationId: 'us-central',
    apiKey: 'AIzaSyDAoW1Mk0K-7dGC4nvMXCZf0jsJia89nU0',
    authDomain: 'riise-4098d.firebaseapp.com',
    messagingSenderId: '112102094490',
    measurementId: 'G-K7WW83T2HV',
  },
  production: false
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
